import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { ReportsService } from '../../services/reports/reports.service';
import { specialFeaturesActions } from '../actions';
import { IState } from '../states';

@Injectable()
export class DashboardSpecialFeaturesEffects {
  constructor(
    private _actions$: Actions,
    private _dashboardStore: Store<IState>,
    private _reportsService: ReportsService,
    private _dashboardService: DashboardService,
  ) {}

  downloadSlaAccountabilityReport$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(specialFeaturesActions.downloadSlaAccountabilityReport),
        withLatestFrom(this._dashboardStore),
        switchMap(([action, store]) =>
          this._reportsService.getSlaAccountabilityReportData(action.shopId, {
            startDateValue: new Date(action.start).getTime(),
            endDateValue: new Date(action.end).getTime(),
          }),
        ),
      ),
    {
      dispatch: false,
    },
  );

  downloadDeliveryPromiseAccountabilityReport$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(specialFeaturesActions.downloadDeliveryPromiseAccountabilityReport),
        withLatestFrom(this._dashboardStore),
        switchMap(([action, store]) =>
          this._reportsService.getDeliveryPromiseAccountabilityReportData(action.shopId, store.dashboard.range),
        ),
      ),
    {
      dispatch: false,
    },
  );

  setSpecialLabelSettings$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(
          specialFeaturesActions.setIsScanOrdersActive,
          specialFeaturesActions.setIsShelfReportActive,
          specialFeaturesActions.setIsSpecialLabelActive,
          specialFeaturesActions.setSpecialLabelOptions,
        ),
        withLatestFrom(this._dashboardStore),
        switchMap(([action, store]) => {
          return this._dashboardService.updateDashboardSettings(action.shopId, {
            specialFeatures: {
              isScanOrdersActive: store.dashboard.specialFeatures.isScanOrdersActive,
              isShelfReportActive: store.dashboard.specialFeatures.isShelfReportActive,
              specialLabel: store.dashboard.specialFeatures.specialLabel,
            },
          });
        }),
      ),
    {
      dispatch: false,
    },
  );
}
